export function authorize() {
  // 微信授权登录
  let redirect_uri = encodeURIComponent(window.location.href.split("?")[0]),
    appid = "wx9e3c495667494b5c";
  let wx_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
  window.location.href = wx_url; // 这个时候页面一定会刷新,进入到给的redirect_uri中
  console.log("授权页面")
}



// WEBPACK FOOTER //
// ./src/lib/js/authorize.js